import axios from 'src/utils/axios';

class AuthApi {
  async login(data = {}) {
    const response = await axios.post('/user/client_session', data);
    return response;
  }

  async getLoginToken(data = {}) {
    const response = await axios.put('/user/client_session', data);
    return response;
  }

  async getUser() {
    const response = await axios.get('/client/client_account/client_account');
    return response;
  }

  async updateUser(data = {}) {
    const response = await axios.put('/client/client_account/client_account', data);
    return response;
  }

  async deleteUser() {
    const response = await axios.delete('/client/client_account/client_account');
    return response;
  }

  async forgotPassword(data = {}, token = '') {
    const response = await axios.put('/client/password_recovery', data);
    return response;
  }

  async getCompany(id) {
    const response = await axios.get(`/company/companies/${id}`);
    return response;
  }
}

export const authApi = new AuthApi();
